import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/apiClient";
import ActivityModule from "@/components/ActivityModule";
import { TrackerTable, PageHeader, Tabs } from "@/components/shared";
import { Trophy } from "lucide-react";

const TABS = [
  { id: "activity", label: "Activity & KPIs" },
  { id: "influencers", label: "Database" },
  { id: "campaigns", label: "Campaigns" },
  { id: "leaderboard", label: "ROI Leaderboard" },
];

function Leaderboard() {
  const { data } = useQuery({ queryKey: ["dashboard"], queryFn: async () => (await api.get("/dashboard")).data });
  const rows = data?.leaderboard || [];
  return (
    <div className="rounded-lg border border-surface-hover bg-surface" data-testid="roi-leaderboard">
      <div className="p-5 border-b border-surface-hover flex items-center gap-2">
        <Trophy className="w-5 h-5 text-gold" />
        <h3 className="font-heading text-lg font-bold">ROI Leaderboard</h3>
        <span className="text-xs text-slatetext ml-2">Ranked by actual return, not follower count</span>
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-slatetext text-xs uppercase border-b border-surface-hover">
            <th className="px-4 py-3 text-left">#</th>
            <th className="px-4 py-3 text-left">Influencer</th>
            <th className="px-4 py-3 text-left">Platform</th>
            <th className="px-4 py-3 text-right">Followers</th>
            <th className="px-4 py-3 text-right">Spend (₹)</th>
            <th className="px-4 py-3 text-right">Campaigns</th>
            <th className="px-4 py-3 text-right">ROI %</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.name} className="border-b border-surface-hover/60 hover:bg-surface-hover/40 transition-colors duration-200">
              <td className="px-4 py-3">{i + 1}</td>
              <td className="px-4 py-3 font-medium">{r.name}</td>
              <td className="px-4 py-3 text-slatetext">{r.platform}</td>
              <td className="px-4 py-3 text-right tabular-nums">{Number(r.followers).toLocaleString("en-IN")}</td>
              <td className="px-4 py-3 text-right tabular-nums">{Number(r.spend).toLocaleString("en-IN")}</td>
              <td className="px-4 py-3 text-right">{r.campaigns}</td>
              <td className={`px-4 py-3 text-right font-bold tabular-nums ${r.roi >= 100 ? "text-[#059669]" : r.roi < 0 ? "text-[#DC2626]" : "text-gold"}`}>{r.roi}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Influencer() {
  const [active, setActive] = useState("activity");
  return (
    <div>
      <PageHeader title="Influencer Marketing" subtitle="Funnel activity → auto KPIs, plus database, campaigns and ROI ranking" />
      <Tabs tabs={TABS} active={active} onChange={setActive} />
      {active === "activity" ? <ActivityModule module="influencer" /> : active === "leaderboard" ? <Leaderboard /> : <TrackerTable id={active} />}
    </div>
  );
}
